import React from 'react';
import { useTypedTranslation } from '@app/hooks';
import { TranslationNamespace } from '@app/models';

interface IProps {
    enumValue: any;
}

export const ApiEnumList = (props: IProps) => {
    const { translation } = useTypedTranslation(TranslationNamespace.apiDescription);
    const { enumValue } = props;

    const enumDescription = (item: any) => {
        let split = enumValue.name.split('.');
        let name = split[split.length - 1];
        name = 'API_' + name + '_' + item.Name;
        name = name.toUpperCase();
        const translatedName = translation(name);
        if (translatedName === name) return item.Name;
        return translatedName;
    };

    return (
        <>
            {enumValue !== undefined && enumValue !== null &&
                <table>
                    <thead>
                        <tr>
                            <td>{translation('ENUM_NAME')}</td>
                            <td>{translation('ENUM_VALUE')}</td>
                            <td>{translation('MEMBER_DESCRIPTION')}</td>
                        </tr>
                    </thead>
                    <tbody>
                        {enumValue.members.map((item: any, index: number) => (
                            <tr key={index}>
                                <td>{item.Name}</td>
                                <td><code>{item.Value}</code></td>
                                <td>{enumDescription(item)}</td>
                            </tr>
                        ))
                        }
                    </tbody>
                </table>
            }
        </>
    );
};
